import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📷", key: "photographer" },
  { emoji: "📱", key: "anApp" },
  { emoji: "💸", key: "tooExpensive" },
  { emoji: "🤷", key: "didntKnowHow" },
]

export default function PetsDecisionMomentPage() {
  return (
    <RadioCardListPage translationKey="petsDecisionMoment" options={OPTIONS} />
  )
}
